import { render, staticRenderFns } from "./ScreenTitleTab.vue?vue&type=template&id=196a2a7e&scoped=true"
import script from "./ScreenTitleTab.vue?vue&type=script&lang=js"
export * from "./ScreenTitleTab.vue?vue&type=script&lang=js"
import style0 from "./ScreenTitleTab.vue?vue&type=style&index=0&id=196a2a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a2a7e",
  null
  
)

export default component.exports